import { Routes } from "@angular/router";
import { LogComponent } from "./final/log/log.component";
import { MainComponent } from "./final/main/main.component";
import { ManagerComponent } from "./final/manager/manager.component";
import { RegComponent } from "./final/reg/reg.component";
import { TestComponent } from "./final/test/test.component";
// import { AdminLayoutComponent } from "./layouts/admin/admin-layout.component";
// import { AuthLayoutComponent } from "./layouts/auth/auth-layout.component";
import { ParticipantComponent } from "./final/participant/participant.component";

export const AppRoutes: Routes = [
  {
    path: "",
    redirectTo: "main",
    pathMatch: "full",
  },
  {
    path: "certi",
    component: ParticipantComponent,
  },
  {
    path: "main",
    component: MainComponent,
  },
  {
    path: "root/log",
    component: LogComponent,
  },
  //   {
  //     path: "root/reg",
  //     component: RegComponent,
  //   },
  {
    path: "root/manager",
    component: ManagerComponent,
  },
  //   {
  //     path: "test",
  //     component: TestComponent,
  //   },
  {
    path: "**",
    redirectTo: "main",
  },
  // {
  //     path: 'ditch/karo',
  //     component: AdminLayoutComponent,
  //     children: [{
  //         path: '',
  //         loadChildren: './dashboard/dashboard.module#DashboardModule'
  //     }, {
  //         path: 'ditch/components',
  //         loadChildren: './components/components.module#ComponentsModule'
  //     }, {
  //         path: 'ditch/forms',
  //         loadChildren: './forms/forms.module#Forms'
  //     }, {
  //         path: 'ditch/tables',
  //         loadChildren: './tables/tables.module#TablesModule'
  //     }, {
  //         path: 'ditch/maps',
  //         loadChildren: './maps/maps.module#MapsModule'
  //     }, {
  //         path: 'ditch/charts',
  //         loadChildren: './charts/charts.module#ChartsModule'
  //     }, {
  //         path: 'ditch/calendar',
  //         loadChildren: './calendar/calendar.module#CalendarModule'
  //     }, {
  //         path: '',
  //         loadChildren: './userpage/user.module#UserModule'
  //     }, {
  //         path: '',
  //         loadChildren: './timeline/timeline.module#TimelineModule'
  //     }, {
  //         path: '',
  //         loadChildren: './widgets/widgets.module#WidgetsModule'
  //     }]
  // }, {
  //     path: 'ditch/karo/pls',
  //     component: AuthLayoutComponent,
  //     children: [{
  //         path: 'pages',
  //         loadChildren: './pages/pages.module#PagesModule'
  //     }]
  // }
];
